import { Box, Grid } from '@material-ui/core';
import React, { useEffect } from 'react';
import ImProductEntryManagementCart from './ImProductEntryManagementCart';
import ImProductEntryManagementHeader from './ImProductEntryManagementHeader';
import ImProductEntryManagementProductList from './ImProductEntryManagementProductList';
import { productsEntryManagementStore } from 'stores/productsEntryManagement.store';

export default function ImProductEntryManagment() {
  const { reset } = productsEntryManagementStore((state: any) => ({ reset: state.reset }));
  useEffect(() => {
    return () => {
      reset();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Grid container>
      <Grid item md={6}>
        <ImProductEntryManagementProductList />
      </Grid>
      <Grid item md={6}>
        <Box display="column">
          <Box ml={1}>
            <ImProductEntryManagementHeader />
          </Box>
          <Box mt={1} ml={1}>
            <ImProductEntryManagementCart />
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
}
